<template>
  <div>
    <div class="row mt10 name-box">
      <div class="col-md-12">
        <div class="row">
          <router-link :to="localizedRoute(designerCategoryPath + '?' + designerAttribute + '=' + getCurrentProduct[designerAttribute])" class="cl-black author uppercase pl8" :class="isRentalProduct ? 'fs-medium-small weight-400' : 'fs-large weight-600 author--sale'">
            {{ designerCheck }}
          </router-link>
          <div id="6ea25396-b018-405b-8836-c37b4597eb3c" />
          <script defer type="application/javascript" :src="`https://trustmate.io/api/widget/6ea25396-b018-405b-8836-c37b4597eb3c/script?product=${getCurrentProduct.parentSku}`" />
        </div>
        <h1 class="mt0 product-name serif capitalize" :class="isRentalProduct ? 'mb0 fs28 weight-500 product-name--rental' : 'mb15 fs-medium weight-500 product-name--sale'">
          {{ getCurrentProduct.name | htmlDecode }}
          <AddToWishlist :product="getCurrentProduct" class="wishlist-button" />
        </h1>
        <slot />
      </div>
    </div>
    <slot name="options" />
  </div>
</template>

<script>
import { ProductMixin } from 'theme/components/core/blocks/Product-v2/ProductMixin.ts'

export default {
  name: 'BaseConfigurableProduct',
  mixins: [ProductMixin]
}
</script>

<style lang="scss" scoped>
.name-box {
  @media (max-width: 767px) {
    margin-bottom: 10px;
  }
}
.author--sale {
  @media (max-width: 767px) {
    font-size: 22px;
  }
}
.product-name {
  position: relative;
  .wishlist-button {
    position: absolute;
    right: 0;
    top: -7px;
  }
  &--rental {
    @media (max-width: 767px) {
      font-size: 26px;
    }
  }
  &--sale {
    @media (max-width: 767px) {
      font-size: 16px;
    }
  }
}
</style>
